import orderApi from "@/api/orderApi";
import webSite from "@/api/webSite";

import {
  getToken,
  setToken,
  removeToken,
  setUserInfo,
  getUserInfo,
  setUserPropagateInfo,
  getUserPropagateInfo,
  removeUserInfo,
  removeUserPropagateInfo,
} from "@/utils/auth";

const user = {
  namespaced: true,
  state: {
    token: getToken(),
    userInfo: getUserInfo(),
    userPropagateInfo: getUserPropagateInfo(),
    luckNum: 0,
    inviteNum: 0,
    userStatus: 0,
    recordDialogVisible: false,
    luckUserList: [],
    luckRecordList: [],


  },
  mutations: {
    luckNum(state, payload) {
      state.luckNum = payload.count;
    },
    inviteNum(state, payload) {
      state.inviteNum = payload.invite_count;
    },
    luckUserList(state, payload) {
      let list = payload.map((e) => {
        return {
          title: `${e.virtual_phone}获得${e.item_name}`,
        };
      });
      state.luckUserList = list;
    },
    luckRecordList(state, payload) {
      state.luckRecordList = payload;
    },

    getUserStatus(state, payload) {
      state.userStatus = payload;
    },

    LOGOUT: (state) => {
      state.token = "";
      state.userInfo = "";
      state.userPropagateInfo = "";
      removeToken();
      removeUserInfo();
      removeUserPropagateInfo();
      localStorage.removeItem("requestTime");
      location.href = location.href + "?time=" + new Date().getTime();
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USERINFO(state, payload) {
      let { user_phone } = payload;
      state.userInfo = user_phone;
      setUserInfo(user_phone);
      
    },
    SET_USERPROOPAGATEINFO(state, payload) {
      let { user_Propagate } = payload;
      state.userPropagateInfo = user_Propagate;
      setUserPropagateInfo(user_Propagate);
    },
    recordDialogVisible(state, payload) {
      state.recordDialogVisible = payload;
    },

  },
  actions: {
    // 登录
    Login({ commit }, params) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await orderApi.login(params);
          let { token, status } = res.data;
          if (status) {
            
            console.log("手机号1111"+  sessionStorage.getItem('phoneNumber'));

            const requestTime = new Date(); // 记录登录时间
            if (!localStorage.requestTime)
            {
              try{
                localStorage.setItem("requestTime", requestTime);
              }catch(e)
              {
                if (e.name === 'QuotaExceededError') {
                  console.error('LocalStorage 已满');
                  localStorage.clear(); // 清理所有存储
                }
                localStorage.setItem("requestTime", requestTime);
              }
            }
            setToken(token);
            commit("SET_TOKEN", token);
            commit("SET_USERINFO", res.data);
            commit("SET_USERPROOPAGATEINFO", res.data);
            window.location.reload()
          }
          resolve(res);
        } catch (error) {

          reject(error);
        }
      });
    },
//临时登录
LoginShortTime({ commit }, params) {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await orderApi.loginShortTime(params);
      let { token, status } = res.data;
      if (status) {

        console.log("手机号1111"+  sessionStorage.getItem('phoneNumber'));

        const requestTime = new Date(); // 记录登录时间
        if (!localStorage.requestTime)
        {
          try{
            localStorage.setItem("requestTime", requestTime);
          }catch(e)
          {
            if (e.name === 'QuotaExceededError') {
              console.error('LocalStorage 已满');
              localStorage.clear(); // 清理所有存储
            }
            localStorage.setItem("requestTime", requestTime);
          }
        }
        setToken(token);
        commit("SET_TOKEN", token);
        commit("SET_USERINFO", res.data);
        commit("SET_USERPROOPAGATEINFO", res.data);
        window.location.reload()
      }
      resolve(res);
    } catch (error) {

      reject(error);
    }
  });
},
    // 登出
    Logout({ state, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await orderApi.logout({ token: state.token });
          let { status } = res.data;
          if (status) {
            commit("LOGOUT");
            // commit("propagateState", 0);
            // commit("propagateUlState", 0);//手机端
            // commit("propagateuL", 0);//pc端
            // commit("propagateButtonType", 0);//手机端
            // commit("propagateButtonAwaitType", 1);//手机端
            // commit("propagateButtonNotType", 1);//手机端
          }

          resolve(res);
        } catch (error) {
          reject(error);
        }
      });
    },

    // 获取抽奖次数
    async luckNum({ commit }, params) {
      const res = await orderApi.luckNum(params);
      commit("luckNum", res.data);
      commit("inviteNum", res.data);
    },

    // 获取中奖名单
    async luckUserList({ commit }) {
      const res = await orderApi.luckUserList();
      commit("luckUserList", res.data);
    },


    // 获取中奖记录
    async luckRecordList({ commit }, params) {
      const res = await orderApi.luckRecordList(params);
      commit("luckRecordList", res.data);
    },

    // 获取预约状态
    async getUserStatus({ commit }, params) {
      const res = await orderApi.getUserStatus(params);
      commit("getUserStatus", res.data.status);
    },

    
  
  },
};

export default user;
